import { Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.html',
  styleUrls: ['./loader.css']
})

export class LoaderComponent {

  constructor() { }

}
